// extracted by mini-css-extract-plugin
export default {"selecterptd":"defaultmapping_selecterptd__oy2Wj","selectecommercetd":"defaultmapping_selectecommercetd__7wZAu","mappingtableContainer":"defaultmapping_mappingtableContainer__m5De7"};